import gql from 'graphql-tag';

export const GET_LIST_OF_PACCAR_ASSET_TYPES = gql`
  query GetListOfPacCarAssetsTypes {
    paccarAssetTypes {
      name
      paccarCode
      type
    }
  }
`;
